<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card
          class="hero4"
          style="font-size:18px; width:auto; height:auto; background-color:rgba(0, 0, 0, 0.6); color:#ffffff; border: 1px solid #00B058; border-radius: 20px;"
        >
          <b-row>
            <b-col
              cols="8"
            >
              <h3>Single line Diagram</h3>
            </b-col>
            <b-col
              cols="4"
              class="d-flex align-items-center justify-content-end"
            >
              <label class="mr-1"> เปิด/ปิดตู้ไฟ </label>
              <toggle-button
                class="mr-1"
                :width="60"
                :height="25"
                :sync="true"
                :value="this.switch.drv1_cmd"
                :color="{checked: '#29CD21', unchecked: '#FF0000', disabled: '#29CD21'}"
                :labels="{checked: 'เปิด', unchecked: 'ปิด'}"
                @change="onChangeActive($event)"
              />
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
            >
              <nbiot_cab_3p
                v-if="diagram_type === '3STW-3MCB-1PW-3MC-3CB' && sem_type === 'nbiot_cab_3p' && (wid === '801')"
              />
              <nbiot_cab_3p_0mcb_2cb_line_check_2w
                v-else-if="diagram_type === '3STW-0MCB-1PW-3MC-2CB-1TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <nbiot_cab_3p_2cb_line_check_2w
                v-else-if="diagram_type === '3STW-3MCB-1PW-3MC-2CB' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <nbiot_cab_3p_3cb_line_check_2w
                v-else-if="diagram_type === '3STW-3MCB-1PW-3MC-3CB' && sem_type === 'nbiot_cab_3p_line_check_2w' && (wid === '928' || wid === '929')"
              />
              <nbiot_cab_3p_3cb_line_check_2w_67
                v-else-if="diagram_type === '3STW-3MCB-1PW-3MC-3CB' && sem_type === 'nbiot_cab_3p_line_check_2w' && (wid === '1183' || wid === '1184' || wid === '1187')"
              />
              <STW3_3MCB_1PW_2MC_2CB_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '3STW-3MCB-1PW-2MC-2CB' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW3_3MCB_1PW_3MC_3CB_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '3STW-3MCB-1PW-3MC-3CB' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW3_3MCB_1PW_1CB_1MC_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '3STW-3MCB-1PW-1CB-1MC' && sem_type === 'nbiot_cab_3p_line_check_1w'"
              />
              <STW0_3MCB_1PW_3MC_2CB_3TFM_1W_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '0STW-3MCB-1PW-3MC-2CB-3TFM' && sem_type === 'nbiot_cab_3p_line_check_1w'"
              />
              <STW0_3MCB_1PW_5CB_5MC_3TFM_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '0STW-3MCB-1PW-5MC-5CB-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW1_1MCB_1PW_3MC_3CB_1TFM_1W_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '3STW-3MCB-1PW-3CB-3MC' && sem_type === 'nbiot_cab_3p_line_check_1w'"
              />
              <STW3_3MCB_1PW_4CB_4MC_2w_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '3STW-3MCB-1PW-4CB-4MC' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW3_3MCB_1PW_2CB_1MC_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '3STW-3MCB-1PW-1MC-2CB' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW0_3MCB_1PW_2CB_2MC_3TFM_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '0STW-3MCB-1PW-2CB-2MC-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW0_3MCB_1PW_4MC_4CB_3TFM_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '0STW-3MCB-1PW-4MC-4CB-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW3_3MCB_1PW_3CB_3MC_3TFM_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '3STW-3MCB-1PW-3CB-3MC-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW0_3MCB_1PW_4MC_4CB_3TFM_4W_67
                v-else-if="equipment === 'iot4g-67' && diagram_type === '0STW-3MCB-1PW-4MC-4CB-3TFM' && sem_type === 'nbiot_cab_3p_line_check_4w'"
              />
              <nbiot_cab_3p_line_check_2w
                v-else-if="diagram_type === '3STW-3MCB-1PW-3MC-3CB' && sem_type === 'nbiot_cab_3p_line_check_2w' && (wid != '928' || wid != '929')"
              />
              <nbiot_cab_3p_line_check_6w
                v-else-if="sem_type === 'nbiot_cab_3p_line_check_6w'"
              />
              <STW0_3MCB_1PW_4MC_4CB_3TFM
                v-else-if="diagram_type === '0STW-3MCB-1PW-4MC-4CB-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w' && (wid === '999')"
              />
              <STW3_3MCB_1PW_4CB_4MC
                v-else-if="diagram_type === '3STW-3MCB-1PW-4MC-4CB' && sem_type === 'nbiot_cab_3p' && (wid === '973' || wid === '983' || wid === '987')"
              />
              <STW3_3MCB_1PW_4MC_4CB
                v-else-if="diagram_type === '3STW-3MCB-1PW-4MC-4CB' && sem_type === 'nbiot_cab_3p' && (wid !== '973' || wid !== '983' || wid !== '987')"
              />
              <STW3_3MCB_1PW_2MC_2CB
                v-else-if="diagram_type === '3STW-3MCB-1PW-2MC-2CB' && sem_type === 'nbiot_cab_3p'"
              />
              <STW3_3MCB_1PW_5MC_5CB
                v-else-if="diagram_type === '3STW-3MCB-1PW-5MC-5CB' && sem_type === 'nbiot_cab_3p'"
              />
              <STW3_3MCB_1PW_6MC_6CB
                v-else-if="diagram_type === '3STW-3MCB-1PW-6MC-6CB' && sem_type === 'nbiot_cab_3p'"
              />
              <STW3_3MCB_1PW_3MC_3CB
                v-else-if="diagram_type === '3STW-3MCB-1PW-3MC-3CB' && sem_type === 'nbiot_cab_3p'"
              />
              <STW3_3MCB_1PW_3CB_3MC_3W_67
                v-else-if="diagram_type === '3STW-3MCB-1PW-3CB-3MC' && sem_type === 'nbiot_cab_3p_line_check_3w'"
              />
              <STW3_3MCB_1PW_4CB_4MC_4W_1N_3CH_67
                v-else-if="diagram_type === '3STW-3MCB-1PW-4CB-4MC-1N-3CH' && sem_type === 'nbiot_cab_3p_line_check_4w' && wid === '1958'"
              />
              <STW0_3MCB_1PW_1CB_1MC_3TFM_3W_67
                v-else-if="diagram_type === '0STW-3MCB-1PW-1CB-1MC-3TFM' && sem_type === 'nbiot_cab_3p_line_check_3w'"
              />
              <STW0_3MCB_1PW_1CB_1MC_3TFM_2W_67
                v-else-if="diagram_type === '0STW-3MCB-1PW-1CB-1MC-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW0_3MCB_1PW_1MC_1CB_3TFM_2W_67
                v-else-if="diagram_type === '0STW-3MCB-1PW-1MC-1CB-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW0_3MCB_1PW_2MC_2CB_3TFM_2W_67
                v-else-if="diagram_type === '0STW-3MCB-1PW-2MC-2CB-3TFM' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
              <STW0_3MCB_1PW_3CB_3MC_3TFM_4W_2N_2_3CH_67
                v-else-if="diagram_type === '0STW-3MCB-1PW-3CB-3MC-3TFM-2N-2-3CH' && sem_type === 'nbiot_cab_3p_line_check_4w'"
              />
              <STW0_3MCB_1PW_3CB_3MC_3TFM_3W_2N_2_3CH_67
                v-else-if="diagram_type === '0STW-3MCB-1PW-3CB-3MC-3TFM-2N-2-3CH' && sem_type === 'nbiot_cab_3p_line_check_3w'"
              />
              <STW0_3MCB_1PW_3CB_3MC_3TFM_2W_2N_2_3CH_67
                v-else-if="diagram_type === '0STW-3MCB-1PW-3CB-3MC-3TFM-2N-2-3CH' && sem_type === 'nbiot_cab_3p_line_check_2w'"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
import STW0_3MCB_1PW_4MC_4CB_3TFM_4W_67 from './diagram/0STW-3MCB-1PW-4MC-4CB-3TFM-4w-67.vue'
// eslint-disable-next-line camelcase
import nbiot_cab_3p_line_check_2w from './diagram/nbiot_cab_3p_line_check_2w.vue'
// eslint-disable-next-line camelcase
import nbiot_cab_3p_line_check_6w from './diagram/nbiot_cab_3p_line_check_6w.vue'
// eslint-disable-next-line camelcase
import nbiot_cab_3p_3cb_line_check_2w from './diagram/nbiot_cab_3p_3cb_line_check_2w.vue'
// eslint-disable-next-line camelcase
import nbiot_cab_3p_3cb_line_check_2w_67 from './diagram/nbiot_cab_3p_3cb_line_check_2w_67.vue'
// eslint-disable-next-line camelcase
import nbiot_cab_3p_0mcb_2cb_line_check_2w from './diagram/nbiot_cab_3p_0mcb_2cb_line_check_2w.vue'
// eslint-disable-next-line camelcase
import nbiot_cab_3p_2cb_line_check_2w from './diagram/nbiot_cab_3p_2cb_line_check_2w.vue'
// eslint-disable-next-line camelcase
import STW0_3MCB_1PW_4MC_4CB_3TFM from './diagram/0STW-3MCB-1PW-4MC-4CB-3TFM.vue'
import STW3_3MCB_1PW_4CB_4MC from './diagram/3STW-3MCB-1PW-4CB-4MC.vue'
import STW3_3MCB_1PW_4MC_4CB from './diagram/3STW-3MCB-1PW-4MC-4CB.vue'
import STW3_3MCB_1PW_5MC_5CB from './diagram/3STW-3MCB-1PW-5MC-5CB.vue'
import STW3_3MCB_1PW_6MC_6CB from './diagram/3STW-3MCB-1PW-6MC-6CB.vue'
import STW3_3MCB_1PW_3MC_3CB from './diagram/3STW-3MCB-1PW-3MC-3CB.vue'
import STW3_3MCB_1PW_3MC_3CB_67 from './diagram/3STW-3MCB-1PW-3MC-3CB-67.vue'
// eslint-disable-next-line camelcase
import nbiot_cab_3p from './diagram/nbiot_cab_3p.vue'
/* eslint-disable global-require */
import STW3_3MCB_1PW_2MC_2CB from './diagram/3STW-3MCB-1PW-2MC-2CB.vue'
/* eslint-disable global-require */
import STW3_3MCB_1PW_2MC_2CB_67 from './diagram/3STW_3MCB_1PW_2MC_2CB_67.vue'
/* eslint-disable global-require */
// eslint-disable-next-line camelcase
import STW3_3MCB_1PW_4CB_4MC_2w_67 from './diagram/3STW-3MCB-1PW-4CB-4MC-2w-67.vue'
/* eslint-disable global-require */
import STW3_3MCB_1PW_2CB_1MC_67 from './diagram/3STW_3MCB_1PW_2CB_1MC_67.vue'
/* eslint-disable global-require */
import STW3_3MCB_1PW_1CB_1MC_67 from './diagram/3STW-3MCB-1PW-1CB-1MC-67.vue'
/* eslint-disable global-require */
import STW0_3MCB_1PW_2CB_2MC_3TFM_67 from './diagram/0STW-3MCB-1PW-2CB-2MC-3TFM-67.vue'
/* eslint-disable global-require */
import STW0_3MCB_1PW_4MC_4CB_3TFM_67 from './diagram/0STW-3MCB-1PW-4MC-4CB-3TFM-67.vue'
/* eslint-disable global-require */
import STW0_3MCB_1PW_3MC_2CB_3TFM_1W_67 from './diagram/0STW-3MCB-1PW-3MC-2CB-3TFM-1w-67.vue'
/* eslint-disable global-require */
import STW1_1MCB_1PW_3MC_3CB_1TFM_1W_67 from './diagram/1STW-1MCB-1PW-3MC-3CB-1TFM-1w-67.vue'
/* eslint-disable global-require */
import STW3_3MCB_1PW_3CB_3MC_3TFM_67 from './diagram/3STW-3MCB-1PW-3CB-3MC-3TFM-1w-67.vue'
/* eslint-disable global-require */
import STW0_3MCB_1PW_5CB_5MC_3TFM_67 from './diagram/0STW-3MCB-1PW-5MC-5CB-3TFM-67.vue'

import STW3_3MCB_1PW_3CB_3MC_3W_67 from './diagram/3STW-3MCB-1PW-3MC-3CB-3w-67.vue'
import STW3_3MCB_1PW_4CB_4MC_4W_1N_3CH_67 from './diagram/3STW-3MCB-1PW-4CB-4MC-4w-1N-3CH-67.vue'
import STW0_3MCB_1PW_1CB_1MC_3TFM_3W_67 from './diagram/0STW-3MCB-1PW-1CB-1MC-3TFM-3w-67.vue'
import STW0_3MCB_1PW_1CB_1MC_3TFM_2W_67 from './diagram/0STW-3MCB-1PW-1CB-1MC-3TFM-2w-67.vue'
import STW0_3MCB_1PW_1MC_1CB_3TFM_2W_67 from './diagram/0STW-3MCB-1PW-1MC-1CB-3TFM-2w-67.vue'
import STW0_3MCB_1PW_2MC_2CB_3TFM_2W_67 from './diagram/0STW-3MCB-1PW-2MC-2CB-3TFM-2w-67.vue'
import STW0_3MCB_1PW_3CB_3MC_3TFM_4W_2N_2_3CH_67 from './diagram/0STW-3MCB-1PW-3CB-3MC-3TFM-4w-2N-2-3CH-67.vue'
import STW0_3MCB_1PW_3CB_3MC_3TFM_3W_2N_2_3CH_67 from './diagram/0STW-3MCB-1PW-3CB-3MC-3TFM-3w-2N-2-3CH-67.vue'
import STW0_3MCB_1PW_3CB_3MC_3TFM_2W_2N_2_3CH_67 from './diagram/0STW-3MCB-1PW-3CB-3MC-3TFM-2w-2N-2-3CH-67.vue'

export default {
  components: {
    BCol,
    BRow,
    BCard,
    // eslint-disable-next-line vue/no-unused-components
    nbiot_cab_3p_line_check_6w,
    nbiot_cab_3p_3cb_line_check_2w,
    nbiot_cab_3p_line_check_2w,
    nbiot_cab_3p_0mcb_2cb_line_check_2w,
    nbiot_cab_3p_3cb_line_check_2w_67,
    nbiot_cab_3p_2cb_line_check_2w,
    nbiot_cab_3p,
    STW0_3MCB_1PW_4MC_4CB_3TFM,
    STW3_3MCB_1PW_4CB_4MC,
    STW3_3MCB_1PW_4MC_4CB,
    STW3_3MCB_1PW_2MC_2CB,
    STW3_3MCB_1PW_5MC_5CB,
    STW3_3MCB_1PW_6MC_6CB,
    STW3_3MCB_1PW_3MC_3CB,
    STW3_3MCB_1PW_2MC_2CB_67,
    STW0_3MCB_1PW_2CB_2MC_3TFM_67,
    STW3_3MCB_1PW_2CB_1MC_67,
    STW0_3MCB_1PW_4MC_4CB_3TFM_67,
    STW0_3MCB_1PW_4MC_4CB_3TFM_4W_67,
    STW3_3MCB_1PW_4CB_4MC_2w_67,
    STW3_3MCB_1PW_1CB_1MC_67,
    STW3_3MCB_1PW_3MC_3CB_67,
    STW0_3MCB_1PW_3MC_2CB_3TFM_1W_67,
    STW1_1MCB_1PW_3MC_3CB_1TFM_1W_67,
    STW3_3MCB_1PW_3CB_3MC_3TFM_67,
    STW0_3MCB_1PW_5CB_5MC_3TFM_67,
    STW3_3MCB_1PW_3CB_3MC_3W_67,
    STW3_3MCB_1PW_4CB_4MC_4W_1N_3CH_67,
    STW0_3MCB_1PW_1CB_1MC_3TFM_3W_67,
    STW0_3MCB_1PW_1CB_1MC_3TFM_2W_67,
    STW0_3MCB_1PW_1MC_1CB_3TFM_2W_67,
    STW0_3MCB_1PW_2MC_2CB_3TFM_2W_67,
    STW0_3MCB_1PW_3CB_3MC_3TFM_4W_2N_2_3CH_67,
    STW0_3MCB_1PW_3CB_3MC_3TFM_3W_2N_2_3CH_67,
    STW0_3MCB_1PW_3CB_3MC_3TFM_2W_2N_2_3CH_67,
  },
  data() {
    return {
      waydetail: '',
      checkLeft1: '',
      checkRight1: '',
      checkLeft2: '',
      checkRight2: '',
      deptid: '',
      markers: [],
      items: [],
      switch: {
        semid: '',
        controller_id: 1,
        drv1_cmd: '',
      },
      sem_type: '',
      diagram_type: '',
      equipment: '',
      wid: '',
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getCenterSem()
    this.checkSwith()
    this.getValueDiagram()
    this.interval = setInterval(() => {
      this.getValueDiagram()
      this.getCenterSem()
      this.checkSwith()
    }, 10000)
  },
  mounted() {
    this.wid = this.$route.query.wid
  },
  methods: {
    onChangeActive(event) {
      this.$swal({
        title: '<span style="color:#000000">ต้องการปิดหรือเปิดตู้ไฟหรือไม่</span>',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.switch.drv1_cmd = event.value
          try {
            await axios.post('/swithSemControl', this.switch)
            if (event.value === true) {
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">เปิดเรียบร้อยแล้ว</span>',
                showConfirmButton: false,
                timer: 1000,
              })
            } else {
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">ปิดเรียบร้อยแล้ว</span>',
                showConfirmButton: false,
                timer: 1000,
              })
            }
            this.getValueDiagram()
            this.checkSwith()
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' กดเพื่อดำเนินการต่อ!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
    checkSwith() {
      axios
        .post('/checkSwithSemControl', { wid: this.$route.query.wid, controller_id: 1 })
        .then(response => {
          this.switch.semid = response.data[0].id
          if (response.data[0].drv1_cmd === 'CH1:CMD01:MT01=1;') {
            this.switch.drv1_cmd = true
          } else {
            this.switch.drv1_cmd = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.switch.semid = response.data[0].id
          this.diagram_type = response.data[0].diagram_type
          this.equipment = response.data[0].equipment
        })
        .catch(error => {
          console.log(error)
        })
    },
    getValueDiagram() {
      axios
        .post('/getDiagram3P', { wid: this.$route.query.wid })
        .then(response => {
          this.sem_type = response.data[0].firmware
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style  lang="scss" scoped>
.headline {
  font-size: 20px;
}
.title {
  color:#FFFFD5
}
.nowrap {
  white-space: nowrap ;
}

.hero4::before {
    content: "";
    background: url(~@/assets/images/icons/semcontrol/dark.jpg) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 0px;
    top : 0px;
    background-size: cover;
    width: 100%;
    height: 100%;
    opacity: 1.0;
    border-radius: 20px;
  }
</style>
